module.exports = __webpack_public_path__ + "img/tag.cd5434d5.svg";